module.exports = "fragment OptionalYearDateFragment on OptionalYearDate {\n  day\n  month\n  year\n}\n"